import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Divider, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import loadingFileIcon from '../../assets/icons/loadingFile.svg';
import { adjustmentsImportJson } from '../../const/exampleFile';
import { AdjustmentType, ImportAdjustmentsStructure } from '../../models/adjustment.types';
import { useStyles as importTeamsUseStyles } from '../../pages/ExaminerTreemap/Actions/ImportTeams.styles';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';
import FileInput from '../FileInput.component';
import { SheetAlreadyConfigured } from './SheetAlreadyConfigured.component';
import { useTranslation } from 'react-i18next';

const exampleFile = adjustmentsImportJson;

export const ImportAdjustments: React.FC<{
  type: AdjustmentType;
  isConfigured?: boolean;
  onValidFileSelected: (parsedAdjustmentsStructure?: ImportAdjustmentsStructure) => void;
  importedFromExternalSystem: boolean;
  onImportFromExternalSystem: () => void;
  selectedSystem?: string;
}> = (props) => {
  const importTeamsClasses = importTeamsUseStyles();
  const [file, setFile] = useState<File>();
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const [validationError, setValidationError] = useState<
    'Załączony plik jest nieprawidłowy.' | 'Wystąpił błąd podczas ładowania.'
  >();

  const { t } = useTranslation()

  const handleFileLoaded = (files: FileList) => {
    if (files.length === 1 && files[0].type === 'application/json') {
      setFileLoading(true);
      setFile(files[0]);
    }
  };

  const parseAdjustmentsFile = (stringifiedJson: string): ImportAdjustmentsStructure => {
    return JSON.parse(stringifiedJson, function (key, value) {
      if (key === 'typArkusza') return; //typArkusze is possible property in the file but it should be ignored
      if (key === 'nazwa') {
        this.name = value;
        return;
      }
      if (key === 'sposobyDostosowania') {
        this.adjustments = value;
        return;
      }
      if (key === 'uprawnieniaDlaDostosowan') {
        this.adjustmentPermissions = value;
        return;
      }
      return value;
    });
  };

  useEffect(() => {
    if (file !== undefined) {
      file
        .text()
        .then((stringifiedJson: string) => {
          try {
            const parsedFile = parseAdjustmentsFile(stringifiedJson);
            setValidationError(undefined);
            props.onValidFileSelected(parsedFile);
          } catch (error) {
            setValidationError(
              error instanceof SyntaxError ? 'Załączony plik jest nieprawidłowy.' : 'Wystąpił błąd podczas ładowania.',
            );
          }
        })
        .finally(() => setFileLoading(false));
    }
  }, [file]);

  const isSioeo = props.selectedSystem === 'SIOEO'

  return (
    <Grid
      container
      flexDirection={'column'}
      alignContent={'center'}
      alignItems={'center'}
      justifyContent={'center'}
      height={'90%'}
    >
      {props.isConfigured !== undefined && props.isConfigured ? (
        <SheetAlreadyConfigured type={props.type} />
      ) : (
        <>
          <Grid item style={{ margin: '30px' }}>
            <Typography fontSize={18} fontWeight={700}>
              {`Import ${props.type === AdjustmentType.means ? 'dostosowań' : 'uprawnień'}`}
            </Typography>
          </Grid>
          {props.importedFromExternalSystem && isSioeo && (
            <Grid item>
              <ButtonOne
                style={{ backgroundColor: '#3560FF' }}
                disabled={!!file}
                variant="contained"
                color="secondary"
                startIcon={<UploadFileIcon />}
                onClick={props.onImportFromExternalSystem}
              >
                ZAIMPORTUJ DANE Z {t('global:shortNames.SIOEO')}
              </ButtonOne>
              <Grid item>
                <Divider>
                  <Typography fontSize={14} style={{ margin: '20px' }}>
                    LUB
                  </Typography>
                </Divider>
              </Grid>
            </Grid>
          )}
          <Grid justifyContent="center" container>
          <Grid item xs={6}>
            <FileInput
              onFilesLoaded={handleFileLoaded}
              hint={'Zaimportowany plik powinien być w formacie json,'}
              exampleFile={exampleFile}
              acceptedFileExtensions={['json']}
            />
          </Grid>
          </Grid>
          {file !== undefined && (
            <Grid item style={{ width: '55%', marginTop: '10px' }}>
              <Grid container alignItems="center">
                <Grid item xs={1}>
                  {fileLoading ? (
                    <img src={loadingFileIcon} alt='ikona pobieranie pliku' />
                  ) : validationError !== undefined ? (
                    <AddCircleIcon htmlColor="#BC0000" style={{ transform: 'rotate(45deg)' }} />
                  ) : (
                    <CheckCircleIcon htmlColor="#347F42" />
                  )}
                </Grid>
                <Grid item xs={10} style={{ textAlign: 'left' }}>
                  <Typography>{file.name}</Typography>
                </Grid>
                <Grid item xs={1}>
                  <Button
                    onClick={() => {
                      props.onValidFileSelected(undefined);
                      setFile(undefined);
                    }}
                    style={{
                      minWidth: 'unset',
                      color: 'rgba(44, 45, 62, 0.8)',
                    }}
                  >
                    <CloseIcon />
                  </Button>
                </Grid>
              </Grid>
              {validationError !== undefined && (
                <div className={importTeamsClasses.validationError}>{validationError}</div>
              )}
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};
